import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {NEWS} from "../news-widget.consts";
import {NewsWidgetState} from "../models/news-widget.state";
import {NewsWidgetController} from "../news-widget.controller";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {NewsWidgetSeeMoreClickEvent} from "../models/news-widget.see-more-click.event";

export class NewsWidgetSeeMoreClickHandler extends AnalyticsEventHandler {
  controller: NewsWidgetController;
  state: NewsWidgetState;
  type = NEWS.ACTION_TYPES.onSeeAllClick;

  static injectables = [...ActionHandler.injectables, AnalyticsService];

  async action(params) {
    const clickEvent: NewsWidgetSeeMoreClickEvent = new NewsWidgetSeeMoreClickEvent(params);

    await this.analyticsService.createEvent(clickEvent);
  }
}